import React from 'react'
import { Route } from 'react-router-dom'
import ForbiddenAccess from 'components/ForbiddenAccess'

import { hasScopes } from './access'

export const PrivateRoute = ({ requiredScope = 'org_admin', component: Component, ...rest }) => (
  <Route
    render={
      props => (
        hasScopes(requiredScope) ? <Component {...props}/> : <ForbiddenAccess />
      )}
    {...rest}
  />
)